<div class="modal-header">
  <div class="header-content">
    <h2 mat-dialog-title class="clean-title">{{ dialogTitle }}</h2>
    <span class="ref-badge"><i class="fa-solid fa-hashtag"></i> {{ data.rowData['v_ladings.alternate_reference'] || data.lading_uuid }}</span>
  </div>
</div>

<mat-dialog-content class="mat-typography custom-scroll no-pad-top">
  <div class="notes-shell">
    <div class="notes-toolbar">
      <div class="notes-toolbar__meta">
        <div class="notes-toolbar__count">{{ entryCountLabel }}</div>
        <div class="notes-toolbar__carrier" *ngIf="carrierName">{{ carrierName }}</div>
      </div>

      <div class="notes-toolbar__actions">
        <button mat-stroked-button type="button" class="btn-tall" (click)="addNote()" [disabled]="!hasCarrierAudience">
          <i class="fa-solid fa-plus"></i>
          <span>Add Note</span>
        </button>
        <button mat-flat-button color="primary" type="button" class="btn-tall shadow-sm" (click)="saveNotes()" [disabled]="saving || !hasCarrierAudience">
          <i class="fa-solid fa-floppy-disk"></i>
          <span>{{ saving ? 'Saving...' : 'Save Notes' }}</span>
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="empty-state">Loading notes...</div>

    <div *ngIf="!loading && notes.length === 0" class="empty-state">
      <div class="empty-icon-wrapper">
        <i class="fa-solid fa-notes-medical"></i>
      </div>
      <h4>{{ hasCarrierAudience ? 'No notes yet' : 'Contact missing' }}</h4>
      <p>{{ hasCarrierAudience ? 'Add the first note.' : 'This lading does not have the required contact UUID, so notes cannot be created.' }}</p>
    </div>

    <div class="notes-stack" *ngIf="!loading && notes.length > 0">
      <mat-card class="note-card shadow-sm border-slate" *ngFor="let note of notes; let i = index">
        <mat-card-content>
          <div class="note-card__header">
            <div class="note-card__author-block">
              <div class="note-card__author-row">
                <span class="note-card__author">{{ note.created_by || 'New note' }}</span>
                <span class="note-card__state" [class.note-card__state--draft]="!note.lading_note_uuid">
                  {{ note.lading_note_uuid ? 'Saved' : 'Draft' }}
                </span>
              </div>
              <div class="note-card__meta">{{ noteMeta(note) }}</div>
            </div>

            <div class="note-card__controls">
              <span class="note-chip">{{ carrierName ? ('Carrier Only: ' + carrierName) : 'Carrier Only' }}</span>

              <button mat-stroked-button type="button" class="btn-danger-light" (click)="deleteNote(i)">
                <i class="fa-solid fa-trash"></i>
                <span>Delete</span>
              </button>
            </div>
          </div>

          <textarea
            #noteTextarea
            [(ngModel)]="note.note"
            class="note-card__textarea"
            rows="5"
            placeholder="Add note details..."
          ></textarea>

          <div class="note-card__footer">
            <span>Note {{ i + 1 }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>

<div class="modal-footer">
  <button mat-button type="button" class="text-slate-500 hover-bg-slate" (click)="close()">Close</button>
</div>
